import { cashWithdrawalApi } from "../../api";

const CashWithdrawalService = {

    /**
     * 💸 Registrar retiro de efectivo
     * POST /api/cash/withdrawals
     */
    withdraw: async (data: any) => {

        const response = await cashWithdrawalApi.add(data);

        return response.data;
    }

};

export default CashWithdrawalService;